import React from "react";
import { convertISOStrToLocaleTimeStr } from "../../../../../Pages/Cameras/utilities";

interface Props {
  realtimeSecondsElapsed: number;
  startDateIsoStr: string;
  timezone: string | undefined;
}

const Timestamp = ({ realtimeSecondsElapsed, startDateIsoStr, timezone }: Props) => {
  const calculateTimestamp = () => {
    const unix = new Date(startDateIsoStr).getTime() + realtimeSecondsElapsed * 1000;
    const currentDateIsoStr = new Date(unix).toISOString();
    return convertISOStrToLocaleTimeStr(timezone || "US/Pacific", currentDateIsoStr);
  };

  return <div>{calculateTimestamp()}</div>;
};

export default Timestamp;
